import { useCallback, useEffect } from 'react'

import { DataBox, useDataBoxSelector, createDataBoxDefault } from 'app/common/data-box-store'
import useCallbackRef from 'app/common/hooks/useCallbackRef'
import SimpleDate from 'app/common/classes/simple-date'

import { PlainInputDate, PlainInputDateProps, dateFormat } from '../../plain-input-date'
import { disabledFutureDays } from '../../plain-date-period'
import PlainLabel from '../../plain-label'

export { dateFormat }

export const inputDateBoxID = 'date' as const

const getDefaultStateDefault = () => SimpleDate.createToday().getStringFormatted(dateFormat)

const dataFilter = createDataBoxDefault<string>(inputDateBoxID, getDefaultStateDefault())

type Props = {
  id: string
  skipUpperSpace?: boolean
  dataBoxData?: DataBox<string>
  getDefaultState?: () => string
} & Omit<PlainInputDateProps, 'value' | 'onChange' | 'onDateChange' | 'id'>

const PlainDatePeriodBox = ({
  id,
  skipUpperSpace,
  dataBoxData = dataFilter,
  getDefaultState = getDefaultStateDefault,
  dateDisabledStatus = disabledFutureDays,
  ...others
}: Props) => {
  const defaultState = useCallbackRef(getDefaultState)
  const value = useDataBoxSelector(dataBoxData, () => dataBoxData.data)

  const handleDateChange = useCallback((val: string) => {
    dataBoxData.updateData(() => val)
  }, [])

  useEffect(() => {
    const defaultData = defaultState.current?.()
    if (defaultData) {
      dataBoxData.setDefault(defaultData)
      dataBoxData.updateData(() => defaultData)
    }
  }, [defaultState, dataBoxData])

  useEffect(
    () => () => {
      dataBoxData.reset()
    },
    [dataBoxData],
  )

  return (
    <>
      <PlainLabel htmlFor={id} skipUpperSpace={skipUpperSpace} displayAsBlock>
        {'Дата:'}
      </PlainLabel>
      <PlainInputDate
        {...others}
        id={id}
        onDateChange={handleDateChange}
        value={value}
        dateDisabledStatus={dateDisabledStatus}
      />
    </>
  )
}

export default PlainDatePeriodBox
